import Swal from "sweetalert2";
export const handleDriverEdit = async (
  driverId,
  {
    setEditingDriver,
    driversData,
    fetchData,
    cars,
    rentals,
    coupons,
    contact,
    drivers,
    tours,
    tourBookings,
    employeeService,
    setCarsData,
    setRentalsData,
    setCouponsData,
    setTransfersData,
    setDriversData,
    setToursData,
    setTourBookingsData,
    setEmployeesData,
    setSeasonalPricing,
    setIsLoading,
    setError,
  }
) => {
  try {
    setEditingDriver(driverId);

    // Find driver data
    const driver = driversData.find((d) => d._id === driverId);
    if (!driver) {
      throw new Error("Driver not found");
    }

    const { value: formValues, dismiss } = await Swal.fire({
      title: "Edit Driver",
      html: `
          <div class="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label for="name" class="block text-sm font-medium text-left mb-1">First Name</label>
              <input id="name" type="text" class="w-full px-3 py-2 border rounded-md" value="${
                driver.name
              }" required>
            </div>
            <div>
              <label for="surname" class="block text-sm font-medium text-left mb-1">Last Name</label>
              <input id="surname" type="text" class="w-full px-3 py-2 border rounded-md" value="${
                driver.surname
              }" required>
            </div>
          </div>
          <div class="mb-4">
            <label for="email" class="block text-sm font-medium text-left mb-1">Email</label>
            <input id="email" type="email" class="w-full px-3 py-2 border rounded-md" value="${
              driver.email
            }" required>
          </div>
          <div class="mb-4">
            <label for="phone" class="block text-sm font-medium text-left mb-1">Phone Number</label>
            <input id="phone" type="text" class="w-full px-3 py-2 border rounded-md" value="${
              driver.phone
            }" required>
          </div>
          <div class="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label for="licenseNumber" class="block text-sm font-medium text-left mb-1">License Number</label>
              <input id="licenseNumber" type="text" class="w-full px-3 py-2 border rounded-md" value="${
                driver.licenseNumber
              }" required>
            </div>
            <div>
              <label for="licenseExpiry" class="block text-sm font-medium text-left mb-1">License Expiry Date</label>
              <input id="licenseExpiry" type="date" class="w-full px-3 py-2 border rounded-md" value="${
                new Date(driver.licenseExpiry).toISOString().split("T")[0]
              }" required>
            </div>
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium text-left mb-1">Vehicle Types</label>
            <div class="grid grid-cols-2 gap-2">
              <div class="flex items-center">
                <input id="car" type="checkbox" class="mr-2" value="car" ${
                  driver.vehicleTypes.includes("car") ? "checked" : ""
                }>
                <label for="car">Car</label>
              </div>
              <div class="flex items-center">
                <input id="minivan" type="checkbox" class="mr-2" value="minivan" ${
                  driver.vehicleTypes.includes("minivan") ? "checked" : ""
                }>
                <label for="minivan">Mini Van</label>
              </div>
              <div class="flex items-center">
                <input id="van" type="checkbox" class="mr-2" value="van" ${
                  driver.vehicleTypes.includes("van") ? "checked" : ""
                }>
                <label for="van">Van</label>
              </div>
              <div class="flex items-center">
                <input id="minibus" type="checkbox" class="mr-2" value="minibus" ${
                  driver.vehicleTypes.includes("minibus") ? "checked" : ""
                }>
                <label for="minibus">Mini Bus</label>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <label for="isActive" class="flex items-center">
              <input id="isActive" type="checkbox" class="mr-2" ${
                driver.isActive ? "checked" : ""
              }>
              <span class="text-sm font-medium">Active</span>
            </label>
          </div>
          <div class="mb-4">
            <label for="notes" class="block text-sm font-medium text-left mb-1">Notes</label>
            <textarea id="notes" class="w-full px-3 py-2 border rounded-md">${
              driver.notes || ""
            }</textarea>
          </div>
        `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Update",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#1e3a8a",
      preConfirm: () => {
        const vehicleTypes = [];
        if (document.getElementById("car").checked) vehicleTypes.push("car");
        if (document.getElementById("minivan").checked)
          vehicleTypes.push("minivan");
        if (document.getElementById("van").checked) vehicleTypes.push("van");
        if (document.getElementById("minibus").checked)
          vehicleTypes.push("minibus");

        if (vehicleTypes.length === 0) {
          Swal.showValidationMessage("Please select at least one vehicle type");
          return false;
        }

        return {
          name: document.getElementById("name").value,
          surname: document.getElementById("surname").value,
          email: document.getElementById("email").value,
          phone: document.getElementById("phone").value,
          licenseNumber: document.getElementById("licenseNumber").value,
          licenseExpiry: document.getElementById("licenseExpiry").value,
          vehicleTypes,
          isActive: document.getElementById("isActive").checked,
          notes: document.getElementById("notes").value,
        };
      },
    });

    if (dismiss) return;

    // Update driver
    await drivers.updateDriver(driverId, formValues);

    await Swal.fire({
      icon: "success",
      title: "Success",
      text: "Driver updated successfully",
      confirmButtonColor: "#1e3a8a",
    });

    fetchData();
  } catch (error) {
    console.error("Error updating driver:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to update driver. Please try again.",
      confirmButtonColor: "#1e3a8a",
    });
  } finally {
    setEditingDriver(null);
  }
};
